import { useNavigate } from "react-router-dom";
import Button from "../../../common/button";
import NotFoundStyleWrapper from "./NotFound.style";

const NotFound = () => {

  const navigate = useNavigate();

  const backToHome = () => {
    navigate('/');
  }

  return (
    <NotFoundStyleWrapper>
      <div className="container">
        <div className="notFoundArea">
          <div className="notFoundContent">
            <h1>404</h1>
            <h2>Page not found</h2>
            <p>
              The page you are looking for might have been removed had its name
              changed or is temporarily unavailable.
            </p>
            <Button lg variant="outline" className="back_btn" onClick={backToHome}> Back to Home </Button>
          </div>
        </div>
      </div>
    </NotFoundStyleWrapper>
  );
};

export default NotFound;
